<script lang="ts">
  import { authState } from './lib/auth.svelte';
  import { router } from './lib/router.svelte';
  import Login from './components/auth/Login.svelte';
  import SetPassword from './components/auth/SetPassword.svelte';
  import ForgotPassword from './components/auth/ForgotPassword.svelte';
  import SignupFlow from './components/signup/SignupFlow.svelte';
  import TeamInvite from './components/staff/TeamInvite.svelte';
  import Dashboard from './components/dashboard/Dashboard.svelte';
  import LoadingSpinner from './components/ui/LoadingSpinner.svelte';

  // Auto-redirect based on auth state
  $effect(() => {
    const redirect = router.shouldRedirect;
    if (redirect) {
      router.navigate(redirect);
    }
  });
</script>

{#if authState.loading}
  <div class="loading-container">
    <LoadingSpinner size="large" light />
    <p>Loading...</p>
  </div>
{:else if router.route === 'login'}
  <Login />
{:else if router.route === 'signup'}
  <SignupFlow />
{:else if router.route === 'join'}
  <TeamInvite />
{:else if router.route === 'reset-password'}
  <ForgotPassword />
{:else if router.route === 'set-password'}
  <SetPassword />
{:else if router.route === 'forgot-password'}
  <ForgotPassword />
{:else if router.route === 'dashboard'}
  <Dashboard />
{:else}
  <div class="not-found">
    <h1>404 - Page Not Found</h1>
    <button onclick={() => router.navigate('login')}>Go to Login</button>
  </div>
{/if}

<style>
  :global(*) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :global(body) {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #f8f9fc;
  }

  .loading-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #4A7DFF 0%, #6B5CE7 100%);
    color: white;
  }

  .loading-container p {
    margin-top: 1.25rem;
    font-size: 1rem;
    font-weight: 500;
    opacity: 0.9;
  }

  .not-found {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    background: linear-gradient(135deg, #4A7DFF 0%, #6B5CE7 100%);
    color: white;
  }

  .not-found h1 {
    font-size: 2rem;
    font-weight: 700;
  }

  .not-found button {
    background: white;
    color: #4A7DFF;
    border: none;
    padding: 0.875rem 1.75rem;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.9375rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .not-found button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
</style>